<template src="./../templates/Filters.html" />

<script setup>
/* eslint-disable no-unused-vars, no-cond-assign, no-param-reassign */

import { onMounted } from 'vue';

import { filters, titleFilter, setFilters } from '../data/filters.js';
import { pagination } from '../data/pagination.js';
import { findAncestor } from '../utils/findAncestor.js';
import { config } from '../config/config.js';

onMounted(() => {

    // set filters on page load
    setFilters();

});

function toggleFilter(event) {

    event.target.parentElement.classList.toggle('active');

}

/*
    the final checkbox of each filter
    needs to close automatically when
    we navigate away using the keyboard.

    That's what this function does!
*/
function closeFilter(event) {

    if (event.type === 'blur' && document.documentElement.dataset.whatinput === 'mouse') {

        return;

    }

    const filter = findAncestor(event.target, 'js-pagelist-filter');

    if (filter) {

        filter.classList.remove('active');

    }

}

function handleCheckbox(event) {

    for (let i = 0; i < filters.length; i++) {

        // find the correct filter
        if (filters[i].id === event.target.dataset.filter) {

            for (let j = 0; j < filters[i].options.length; j++) {

                // find the correct filter option
                if (filters[i].options[j].id === event.target.id) {

                    // reset our pagination - because our results are about to change!
                    pagination.offset = 0;

                    // change the filter option's 'checked' attribute
                    filters[i].options[j].checked = event.target.checked;

                    return;

                }

            }

        }

    }

}

</script>
